import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { MCGRNewRequestSettlementScopeControlName } from '../costs-section/costs-section-form.model';
import {
  MCGRNewRequestOtherSourceSettlementScopeControlName,
  MCGROtherSourceSettlementScopeFormGroup,
} from './other-source-settlement-scope-form-array.model';

@Injectable({
  providedIn: 'root',
})
export class MCGROtherSourceSettlementScopeFormArrayService {
  constructor(private formBuilder: UntypedFormBuilder) {}

  getFormGroup(): FormGroup<MCGROtherSourceSettlementScopeFormGroup> {
    return this.formBuilder.group({
      [MCGRNewRequestOtherSourceSettlementScopeControlName.Source]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
      [MCGRNewRequestSettlementScopeControlName.Scope]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
      [MCGRNewRequestSettlementScopeControlName.Amount]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
      [MCGRNewRequestSettlementScopeControlName.PercentageShare]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
    });
  }
}
